import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

/** The Brief prototype's shared quotation treatment, separate from check status. */
export function AdvisorySidebarQuote({ children }: { children: string }) {
  return (
    <Box
      component="blockquote"
      sx={theme => ({
        margin: 0,
        marginTop: 1.5,
        borderLeft: `2px solid ${alpha(theme.colors.lavender, 0.35)}`,
        paddingLeft: 2,
        color: theme.colors.inkSecondary,
        fontSize: 16,
        lineHeight: 1.6,
        fontStyle: 'italic',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere',
        minWidth: 0,
      })}
    >
      <Box
        component="mark"
        sx={theme => ({ backgroundColor: alpha(theme.colors.lavender, 0.1), color: 'inherit' })}
      >
        “{children}”
      </Box>
    </Box>
  );
}
